import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { successToast, errorToast } from "../../Utils/toast";
import { createLead } from "../../redux/services/leadServices/Lead.Services";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import {
  allactivestaff,
} from "../../redux/services/Staff Services/Staff.Services";
import { ActiveUserList } from "../../redux/services/User Services/User.Services"

function AddLead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    source: "Website",
    assigned_to: "",
    customer_name: "",
    vendor_id: "",
    mobile: "",
    email: "",
    company_name: "",
    // date: "",
    estimate_amount: "",
    address: "",
    remark: "",
  });
  const adminId = useSelector(
    (state) => state.auth?.user?.id || state.auth?.user?.admin_id
  );
  const validate = () => {
    let newErrors = {};
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
    }
    else if (formData.mobile.length !== 10) {
      newErrors.mobile = "Mobile number must be 10 digits";
    }
    if (!formData.vendor_id) {
      newErrors.vendor_id = "Please select Vendor";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await allactivestaff();

        setUsers(res?.data || []);
      } catch (error) {
        console.log("Staff API error:", error);
      }
    };
    fetchUsers();
  }, []);


  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const res = await ActiveUserList();
        setVendors(res?.data || []);
      } catch (error) {
        console.log("Staff API error:", error);
      }
    };
    fetchVendor();
  }, []);
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "mobile") {
      value = value.replace(/\D/g, "");
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => {
      const updated = { ...prev };

      if (name === "mobile") {
        if (value.length === 10) {
          delete updated.mobile;
        }
      }
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setIsLoading(true);
      const payload = {
        ...formData,
        name: formData.customer_name,
        email: formData.email,
        remark: formData.remark,
      };
      const response = await createLead(payload);
      successToast("Lead Created Successfully");

      navigate(-1);
    } catch (error) {
      console.log(error);

      errorToast("Failed To Create Lead");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
        <div className="title_member">
          <h4>Add Lead</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Add Lead</span>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <button
            className="add-btn"
            onClick={() => navigate(-1)}
          >
            Lead List
          </button>
          {formData.vendor_id && (
            <button
              className="lead-btn btn-import"
              onClick={() =>
                dispatch(
                  openModal({
                    type: "import-lead",
                    title: "Import Leads",
                    data: null
                  })
                )
              }
            >
              Import Lead
            </button>
          )}
        </div>
      </div>
      <div className="main_page">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="container">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label>Source</label>
                    <select
                      className="form-control custumform"
                      name="source"
                      value={formData.source}
                      onChange={handleChange}
                    >
                      <option value="Website">Website</option>
                      <option value="Facebook">Facebook</option>
                      <option value="Google">Google</option>
                      <option value="Instagram">Instagram</option>
                      <option value="IndiaMART">IndiaMART</option>
                      <option value="Justdial">Justdial</option>
                    </select>
                  </div>


                   <div className="col-md-6 mb-3">
                    <label>Select Vendor</label>
                    <select
                      className="form-select"
                      name="vendor_id"
                      value={formData.vendor_id}
                      onChange={handleChange}
                    >
                      <option value="">Select Vendor </option>
                      {vendors.map((vendor) => (
                        <option key={vendor.id} value={vendor.id}>
                          {vendor.name && vendor.mobile
                            ? `${vendor.name} / ${vendor.mobile}`
                            : vendor.name || vendor.mobile}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Assign Staff</label>
                    <select
                      className="form-select"
                      name="assigned_to"
                      value={formData.assigned_to}
                      onChange={handleChange}
                    >
                      <option value="">Select User (optional)</option>
                      {users.map((user) => (
                        <option key={user.id} value={user.id}>
                          {user.name}
                        </option>
                      ))}
                    </select>
                  </div>
                 
                  <div className="col-md-6 mb-3">
                    <label>Customer Name</label>
                    <input
                      type="text"
                      className="form-control custumform"
                      name="customer_name"
                      value={formData.customer_name}
                      onChange={handleChange}
                      placeholder="Enter Customer Name"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Mobile Number<span className="text-danger">*</span></label>

                    <input
                      type="text"
                      className={`form-control custumform ${errors.mobile ? "is-invalid" : ""
                        }`}
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      maxLength={10}
                      placeholder="Enter Mobile Number"
                    />

                    {errors.mobile && (
                      <small className="text-danger">
                        {errors.mobile}
                      </small>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Email</label>

                    <input
                      type="email"
                      className="form-control custumform"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter Email"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label>Company Name</label>
                    <input
                      type="text"
                      className="form-control custumform"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleChange}
                      placeholder="Enter Company Name"
                    />
                  </div>

                  {/* Followup Date */}
                  {/* <div className="col-md-6 mb-3">
                  <label>Followup Date</label>

                  <input
                    type="date"
                    className="form-control custumform"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                  />
                </div> */}

                  {/* Estimate Amount */}
                  {/* <div className="col-md-6 mb-3">
                  <label>Estimate Amount</label>

                  <input
                    type="number"
                    className="form-control custumform"
                    name="estimate_amount"
                    value={formData.estimate_amount}
                    onChange={handleChange}
                    placeholder="Enter Estimate Amount"
                  />
                </div> */}

                  {/* Reference */}
                  {/* <div className="col-md-6 mb-3">
                  <label>Reference</label>

                  <input
                    type="text"
                    className="form-control custumform"
                    name="reference"
                    value={formData.reference}
                    onChange={handleChange}
                    placeholder="Enter Reference"
                  />
                </div> */}

                  {/* Address */}
                  <div className="col-md-12 mb-3">
                    <label>Address</label>
                    <textarea
                      className="form-control custumform"
                      rows="3"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter Address"
                    />
                  </div>

                  {/* Remarks */}
                  {/* <div className="col-md-12 mb-3">
                  <label>Remarks</label>

                  <textarea
                    className="form-control custumform"
                    rows="3"
                    name="remark"
                    value={formData.remark}
                    onChange={handleChange}
                    placeholder="Enter Remarks"
                  />
                </div> */}

                  {/* Button */}
                  <div className="col-md-12">
                    <div className="d-flex justify-content-end">
                      <div className="button_submit">
                        <button
                          type="submit"
                          className="total_btn"
                          disabled={isLoading}
                        >
                          {isLoading ? "Loading..." : "Save Lead"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddLead;